import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Card, Table, Input, Layout, Radio, Form, Col, Space, Avatar, Select, Button } from "antd";
import dayjs from "dayjs";
import "./Users.scss";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useHistory, useLocation } from "react-router-dom";
import { usersStore } from "../../store/user/UsersStore";
import { FilterBar } from "../../components/filter/FilterBar";
import { UserLink } from "../../components/UserLink/UserLink";
import { EditOutlined } from "@ant-design/icons";
import { EditUserDlg } from "./components/EditUserDlg";
import { fmtDateTime, sleep } from "../../common/Utils";
import { userEditStore } from "../../store/user/UserEditStore";
import moment from "moment";
import { SortOrder } from "antd/lib/table/interface";
import { Store } from "../../store/Store";
import { userUpdateChooseCommunityStore } from "../../store/user/UserUpdateChooseCommunityStore";
import { SelectCommunityDlg } from "../../components/community/SelectCommunityDlg";
import { SexOffenderIcon } from "../../components/SexOffenderIcon";
import VolunteerHistoryDlg from "../volunteer/components/VolunteerHistoryDlg";

dayjs.extend(customParseFormat);

export const Users = observer(() => {
  const store = usersStore;
  const setCommunityStore = userUpdateChooseCommunityStore;

  const location = useLocation();

  const history = useHistory();

  const [volunteerHistoryVisible, setVolunteerHistoryVisible] = useState(false);
  const [volunteerHistoryUserId, setVolunteerHistoryUserId] = useState(null);

  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  const onStatus = (status) => {
    const query = new URLSearchParams({ status });
    history.push({
      search: query.toString(),
    });
  };

  const setCommunity = (id) => {
    setCommunityStore.show(id);
  };

  const edit = (id) => {
    userEditStore.edit(id);
  };

  const closeEdit = async (refresh) => {
    userEditStore.close();
    if (refresh) {
      await sleep(3000);
      store.refresh();
    }
  };

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const onChange = (pagination, filters, sorter, { action }) => {
    if (action === "sort") {
      store.sortedInfo = sorter;
      store.refresh();
    }
  };

  const showVolunteerHistory = (userId) => {
    setVolunteerHistoryUserId(userId);
    setVolunteerHistoryVisible(true);
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Full Name",
      dataIndex: "name",
      key: "firstName.keyword",
      className: "text-left",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (_, r) => <UserLink userId={r.id} name={r.name} fullName={r.name} />,
      sortOrder: store.sortedInfo.columnKey === "firstName.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (_, r) => <div>{r.role?.map((x) => (x == "Child" ? "Minor" : x)).join(", ")}</div>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email.keyword",
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "email.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Mobile Number",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "Verification Status",
      dataIndex: "state",
      key: "state",
    },
    {
      title: "SO Check",
      dataIndex: ["sexOffender", "state"],
      key: "so",
      render: (t, r) => <SexOffenderIcon type={t} />,
    },
    {
      title: "Selected FM Community",
      dataIndex: ["chooseCommunity", "name"],
      key: "choose",
      render: (t, r) => (
        <div>
          {t} {<EditOutlined onClick={() => setCommunity(r.id)} />}
        </div>
      ),

      // key: "email.keyword",
      // sorter: true,
      // sortOrder: store.sortedInfo.columnKey === "email.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },

    // {
    //   title: "Affiliate Org",
    //   dataIndex: "orgs",
    //   render: (items, r) => (
    //     <div>
    //       {items.map((c) => (
    //         <div key={c.id}>{c.name}</div>
    //       ))}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Community Leadership",
    //   dataIndex: "leaderships",
    //   render: (items, r) => (
    //     <div>
    //       {r.items?.map((c) => (
    //         <div key={c.id}>{c.name}</div>
    //       ))}
    //     </div>
    //   ),
    // },
    {
      title: "Invitation Code",
      key: "invited.code.keyword",
      sorter: true,
      sortOrder:
        store.sortedInfo.columnKey === "invited.code.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
      render: (_, r) => (
        <Space>
          <span>{r.invited?.code}</span>
          {r.invited?.userName && <span>{r.invited?.userName}</span>}
        </Space>
      ),
    },
    {
      title: "Registration Time",
      dataIndex: "createDate",
      align: "center" as const,
      key: "createDate",
      sorter: (a, b) => moment(a.createDate).valueOf() - moment(b.createDate).valueOf(),
      render: (t, r) => fmtDateTime(t),
      sortOrder: store.sortedInfo.columnKey === "createDate" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    // {
    //   title: "Verified",
    //   dataIndex: "status",
    //   align: "center" as const,
    //   key: "status",
    //   sorter: (a, b) => a.status?.localeCompare(b.status),
    // },
    // {
    //   title: "Division",
    //   dataIndex: "division",
    //   // sorter: (a, b) => (a.division ? a.division.name : "").localeCompare(b.division ? b.division.name : ""),
    //   // render: (d, r) => <div>{d ? `${d.name} @${d.region?.name}` : null}</div>,
    // },
    // {
    //   title: "Community",
    //   dataIndex: "community",
    //   // sorter: (a, b) => (a.division ? a.division.name : "").localeCompare(b.division ? b.division.name : ""),
    //   // render: (d, r) => <div>{d ? `${d.name} @${d.region?.name}` : null}</div>,
    // },
    {
      title: "App Status",
      dataIndex: "lastActivity",
      align: "center" as const,
      key: "lastActivity",
      sorter: (a, b) => moment(a.lastActivity).valueOf() - moment(b.lastActivity).valueOf(),
      render: (t, r) => `${t ? fmtDateTime(t) : "Inactive"}`,
      sortOrder: store.sortedInfo.columnKey === "lastActivity" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "App Avg. Rating",
      align: "center" as const,
      dataIndex: "appRate",
      sorter: (a, b) => a.appRate - b.appRate,
      key: "appRating",
      sortOrder: store.sortedInfo.columnKey === "appRating" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "User Avg. Rating",
      align: "center" as const,
      dataIndex: "userRate",
      key: "userRating",
      sorter: (a, b) => a.userRate - b.userRate,
      sortOrder: store.sortedInfo.columnKey === "userRating" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    // {
    //   title: "Un-Resolved",
    //   dataIndex: "newFbCount",
    //   sorter: (a, b) => a.newFbCount - b.newFbCount,
    //   render: (t, r) => (
    //     <span onClick={() => showFeedback(r)} className="link">
    //       <Badge
    //         count={t || 0}
    //         showZero
    //         style={
    //           t
    //             ? { backgroundColor: "orange" }
    //             : {
    //                 backgroundColor: "#fff",
    //                 color: "#999",
    //                 boxShadow: "0 0 0 1px #d9d9d9 inset",
    //               }
    //         }
    //       />
    //     </span>
    //   ),
    // },
    {
      title: "",
      key: "actions2",
      render: (t, r) => (
        <Button type="link" onClick={() => showVolunteerHistory(r.id)}>
          Volunteer History
        </Button>
      ),
    },
    {
      title: "",
      key: "actions",
      render: (t, r) => (Store.isDivision ? null : <div>{<EditOutlined onClick={() => edit(r.id)} />}</div>),
    },
  ];

  // const { kw } = vm.filter;
  // const kw2 = (kw || "").toLowerCase();
  // let ds = [];
  // let ds =  vm.list?.filter(
  //   x =>
  //     x.user.firstName.toLowerCase().indexOf(kw2) >= 0 ||
  //     x.user.lastName.toLowerCase().indexOf(kw2) >= 0
  // );
  // if (community)
  //   ds = ds.filter(
  //     x => x.user.communities.filter(x => x.id === community).length > 0
  //   );

  return (
    <Layout.Content className="padding24">
      <div>
        <Radio.Group size="large" value={store.filter.status} onChange={(e) => onStatus(e.target.value)}>
          <Radio.Button value="all">All</Radio.Button>
          <Radio.Button value="unverified">Unverified</Radio.Button>
        </Radio.Group>
      </div>

      <FilterBar store={store}>
        <Col span={8}>
          <Form.Item label="Email">
            <Input allowClear value={store.filter.email} onChange={(e) => (store.filter.email = e.target.value)} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Mobile Number">
            <Input allowClear value={store.filter.mobile} onChange={(e) => (store.filter.mobile = e.target.value)} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="User Name">
            <Input allowClear value={store.filter.name} onChange={(e) => (store.filter.name = e.target.value)} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="SO Check">
            <Select
              style={{ width: "100%" }}
              placeholder="Please select"
              defaultValue={store.filter.sexOffenderState}
              onChange={(e) => (store.filter.sexOffenderState = e)}
            >
              <Select.Option value="">All</Select.Option>
              <Select.Option value="Pass">Not Sex Offender</Select.Option>
              <Select.Option value="ReviewNeeded">Need Review</Select.Option>
              <Select.Option value="Fail">Is Sex Offender</Select.Option>
              <Select.Option value="Unknown">Unknown</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Role">
            <Select
              style={{ width: "100%" }}
              placeholder="Please select"
              defaultValue={store.filter.role}
              onChange={(e) => (store.filter.role = e)}
            >
              <Select.Option value="">All</Select.Option>
              <Select.Option value="Child">Minor</Select.Option>
              <Select.Option value="Adult">Just an Adult</Select.Option>
              <Select.Option value="Student">Adult Student</Select.Option>
              <Select.Option value="Parent">Adult Parent</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Invitation Code or Name">
            <Input
              allowClear
              value={store.filter.invitation}
              onChange={(e) => (store.filter.invitation = e.target.value)}
            />
          </Form.Item>
        </Col>
      </FilterBar>

      <Card size="small">
        {/* <Descriptions title="Summary">
          <Descriptions.Item label="Number of Fundraiser"> {store.data.total || 0} </Descriptions.Item>
          <Descriptions.Item label="Average Approval Time"> </Descriptions.Item>
        </Descriptions> */}
        <Table
          onChange={onChange}
          size="small"
          pagination={{ ...store.pagination, onChange: onPage }}
          loading={store.loading}
          rowKey="id"
          columns={columns}
          dataSource={store.data.items}
          scroll={{ x: 'max-content' }}
          />
        {userEditStore.visible && <EditUserDlg onClose={closeEdit} />}
        {setCommunityStore.visible && (
          <SelectCommunityDlg
            visible={setCommunityStore.visible}
            onClose={() => setCommunityStore.close()}
            onSelected={(id) => setCommunityStore.save(id)}
            communities={setCommunityStore.communities}
          />
        )}
        {volunteerHistoryVisible && volunteerHistoryUserId && (
          <VolunteerHistoryDlg
            visible={volunteerHistoryVisible}
            onClose={() => setVolunteerHistoryVisible(false)}
            userId={volunteerHistoryUserId}
          />
        )}
      </Card>
    </Layout.Content>
  );
});
